import { adaptFormItemResponseToFormFields } from '../core';
import {
  adaptAddressGroupResponse,
  adaptFieldsGroupRestrictionResponse,
  stampGuardedFieldError,
} from '../utilities';
import { FieldsGroupFormField, IFormBase } from '@/forms/typings';
import { FieldsGroupFormFieldBuilder } from '@/forms/builders';
import { FormFieldsGroupResponseDTO, FormItemTypeDTO } from '@/api/base/DTOs';

const UNSUPPORTED_FORM_ITEM_TYPES = [
  //? This FormItemType is for internal use of the API
  FormItemTypeDTO.HiddenField,
];

export const adaptFormItemResponseToFieldsGroup = (
  sectionItemResponse: FormFieldsGroupResponseDTO,
  parentFieldId?: IFormBase['fieldId'],
): FieldsGroupFormField => {
  const filteredChildren = sectionItemResponse.children.filter(
    child => !UNSUPPORTED_FORM_ITEM_TYPES.includes(child.formItemType),
  );

  // Calculate hasAnyValue excluding hidden fields
  const hasAnyValue =
    sectionItemResponse.notApplicable ||
    sectionItemResponse.children.some(
      child =>
        !UNSUPPORTED_FORM_ITEM_TYPES.includes(child.formItemType) &&
        child.hasAnyValue,
    );

  let fieldGroupForm = new FieldsGroupFormFieldBuilder()
    .fieldId(sectionItemResponse.fieldID)
    .name(sectionItemResponse.title)
    .hasAnyValue(hasAnyValue)
    .notApplicable(sectionItemResponse.notApplicable)
    .showNotApplicable(sectionItemResponse.showNotApplicable)
    .parentFieldId(parentFieldId)
    .isRequired(sectionItemResponse.isRequired)
    .address(adaptAddressGroupResponse(sectionItemResponse.address))
    .fields(
      filteredChildren.map(child =>
        adaptFormItemResponseToFormFields(child, sectionItemResponse.fieldID),
      ),
    );

  if (sectionItemResponse.hint) {
    fieldGroupForm = fieldGroupForm.hint(sectionItemResponse.hint);
  }

  if (sectionItemResponse.hintImageUrl) {
    fieldGroupForm = fieldGroupForm.hintImageUrl(
      sectionItemResponse.hintImageUrl,
    );
  }

  if (sectionItemResponse.isCollapsible) {
    fieldGroupForm = fieldGroupForm.isCollapsible(
      sectionItemResponse.isCollapsible,
    );
  }

  const restriction = adaptFieldsGroupRestrictionResponse(
    sectionItemResponse.restriction,
  );
  if (restriction) {
    fieldGroupForm = fieldGroupForm.restriction(restriction);
  }

  return stampGuardedFieldError(fieldGroupForm.build());
};
